import {createEntitySlice} from 'utils/createEntitySlice';
import {ClientVisit} from 'types/clientVisit';
import {ClientVisitThunks} from './clientVisitThunks';

export interface ClientVisitState {
  status: 'idle' | 'loading' | 'succeeded' | 'failed';
  error: string | null;
  clientVisits?: any;
  pagy?: any;
  clientVisit?: any;
  isEditing?: boolean;
  activeTab?: string;
}

const initialState: ClientVisitState = {
  status: 'idle',
  error: null,
  clientVisits: [],
  clientVisit: {},
  pagy: {},
  isEditing: false,
  activeTab: 'Documents',
};

const clientVisitSlice = createEntitySlice<ClientVisit>({
  name: 'clientVisit',
  initialState,
  thunks: ClientVisitThunks,
  entityKey: 'clientVisit',
  entitiesKey: 'clientVisits',
  reducers: {},
});

export const {
  setEntity: setClientVisit,
  setIsEditing,
  setActiveTab,
} = clientVisitSlice.actions;
export {initialState as clientVisitInitialState};
export default clientVisitSlice.reducer;

